import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import axios from "axios";
import locale_en from "./language/en.json";
import locale_sk from "./language/sk.json";
import locale_cz from "./language/cz.json";
import locale_de from "./language/de.json";

const initI18n = async () => {
  if (window.location.origin === "http://localhost:3000") {
    try {
      i18n.use(initReactI18next).init({
        debug: true,
        fallbackLng: "en",
        lng: localStorage.getItem("lang") || "en",
        interpolation: {
          escapeValue: false,
        },
        resources: {
          sk: {
            translation: locale_sk,
          },
          en: {
            translation: locale_en,
          },
          cs: {
            translation: locale_cz,
          },
          de: {
            translation: locale_de,
          },
        },
      });
    } catch (e) {}
  } else {
    const url = window.location.origin + window.location.pathname + "locale";

    try {
      const locale_en = (await axios.get(`${url}/en.json`)).data;
      const locale_sk = (await axios.get(`${url}/sk.json`)).data;
      const locale_cz = (await axios.get(`${url}/cz.json`)).data;
      const locale_de = (await axios.get(`${url}/de.json`)).data;

      i18n.use(initReactI18next).init({
        debug: true,
        fallbackLng: "en",
        lng: localStorage.getItem("lang") || "en",
        interpolation: {
          escapeValue: false,
        },
        resources: {
          sk: {
            translation: locale_sk,
          },
          en: {
            translation: locale_en,
          },
          cs: {
            translation: locale_cz,
          },
          de: {
            translation: locale_de,
          },
        },
      });
    } catch (error) {
      console.error("Error loading translations:", error);
    }
  }
};

initI18n();

export default i18n;
